import { createAction } from "redux-actions";

export const PURPOSE_CHANGED = "PURPOSE_CHANGED";
export const purposeChanged = createAction(PURPOSE_CHANGED);

export const PURPOSES_CHANGED = "PURPOSES_CHANGED";
export const purposesChanged = createAction(PURPOSES_CHANGED);

export const REGIONS_CHANGED = "REGIONS_CHANGED";
export const regionsChanged = createAction(REGIONS_CHANGED);

export const SUB_PURPOSE_CHANGED = "SUB_PURPOSE_CHANGED";
export const subPurposeChanged = createAction(SUB_PURPOSE_CHANGED);

export const SUB_PURPOSES_CHANGED = "SUB_PURPOSES_CHANGED";
export const subPurposesChanged = createAction(SUB_PURPOSES_CHANGED);

export const COUNTRIES_CHANGED = "COUNTRIES_CHANGED";
export const countriesChanged = createAction(COUNTRIES_CHANGED);

export const PARAMETERS_CHANGED = "PARAMETERS_CHANGED";
export const parametersChanged = createAction(PARAMETERS_CHANGED);

export const REGULATIONS_CHANGED = "REGULATIONS_CHANGED";
export const regulationsChanged = createAction(REGULATIONS_CHANGED);

export const REGULATION_NAME_CHANGED = "REGULATION_NAME_CHANGED";
export const regulationNameChanged = createAction(REGULATION_NAME_CHANGED);

export const EXPAND_PARAMETER_PANEL = "EXPAND_PARAMETER_PANEL";
export const expandParameterPanel = createAction(EXPAND_PARAMETER_PANEL);

export const COLLAPSE_PARAMETER_PANEL = "COLLAPSE_PARAMETER_PANEL";
export const collapseParameterPanel = createAction(COLLAPSE_PARAMETER_PANEL);

export const RESET_ALL = "RESET_ALL";
export const resetAll = createAction(RESET_ALL);

export const TABLE_MAIN_REGULATIONS_PAGE = "TABLE_MAIN_REGULATIONS_PAGE";
export const tableMainRegulationsPage = createAction(TABLE_MAIN_REGULATIONS_PAGE);

export const TABLE_MAIN_REGULATIONS_SORTED = "TABLE_MAIN_REGULATIONS_SORTED";
export const tableMainRegulationsSorted = createAction(TABLE_MAIN_REGULATIONS_SORTED);

export const TABLE_MAIN_REGULATIONS_EXPANDED = "TABLE_MAIN_REGULATIONS_EXPANDED";
export const tableMainRegulationsExpanded = createAction(TABLE_MAIN_REGULATIONS_EXPANDED);

export const FOCUS_REGULATION_ID = "FOCUS_REGULATION_ID";
export const focusRegulationId = createAction(FOCUS_REGULATION_ID);

export const FOCUS_PARAMETER_ID = "FOCUS_PARAMETER_ID";
export const focusParameterId = createAction(FOCUS_PARAMETER_ID);

export const FOCUS_COUNTRY_ID = "FOCUS_COUNTRY_ID";
export const focusCountryId = createAction(FOCUS_COUNTRY_ID);

export const FOCUS_PARAMETER_AND_COUNTRY_ID = "FOCUS_PARAMETER_AND_COUNTRY_ID";
export const focusParameterAndCountryId = createAction(FOCUS_PARAMETER_AND_COUNTRY_ID);

export const TABLE_MAIN_STANDARDS_PAGE = "TABLE_MAIN_STANDARDS_PAGE";
export const tableMainStandardsPage = createAction(TABLE_MAIN_STANDARDS_PAGE);

export const TABLE_MAIN_STANDARDS_SORTED = "TABLE_MAIN_STANDARDS_SORTED";
export const tableMainStandardsSorted = createAction(TABLE_MAIN_STANDARDS_SORTED);

export const TABLE_MAIN_STANDARDS_EXPANDED = "TABLE_MAIN_STANDARDS_EXPANDED";
export const tableMainStandardsExpanded = createAction(TABLE_MAIN_STANDARDS_EXPANDED);

export const SHOW_ONLY_REGULATIONS_WITH_NUMERICAL_STANDARDS_CLICKED = "SHOW_ONLY_REGULATIONS_WITH_NUMERICAL_STANDARDS_CLICKED";
export const showOnlyRegulationsWithNumericalStandardsClicked = createAction(SHOW_ONLY_REGULATIONS_WITH_NUMERICAL_STANDARDS_CLICKED);

export const SHOW_ONLY_MANDATORY_CLICKED = "SHOW_ONLY_MANDATORY_CLICKED";
export const showOnlyMandatoryClicked = createAction(SHOW_ONLY_MANDATORY_CLICKED);

export const SHOW_ONLY_CURRENT_CLICKED = "SHOW_ONLY_CURRENT_CLICKED";
export const showOnlyCurrentClicked = createAction(SHOW_ONLY_CURRENT_CLICKED);

export const MIN_MAX_CHANGED = "MIN_MAX_CHANGED";
export const minMaxChanged = createAction(MIN_MAX_CHANGED);

export const RESET_PARAMETER_AND_COUNTRY_ID = "RESET_PARAMETER_AND_COUNTRY_ID";
export const resetParameterAndCountryId = createAction(RESET_PARAMETER_AND_COUNTRY_ID);

// Connected filter actions
export const CONNECTED_PURPOSE_CHANGED = "CONNECTED_PURPOSE_CHANGED";
export const connectedPurposeChanged = createAction(CONNECTED_PURPOSE_CHANGED);

export const CONNECTED_COUNTRIES_CHANGED = "CONNECTED_COUNTRIES_CHANGED";
export const connectedCountriesChanged = createAction(CONNECTED_COUNTRIES_CHANGED);

export const CONNECTED_PARAMETERS_CHANGED = "CONNECTED_PARAMETERS_CHANGED";
export const connectedParametersChanged = createAction(CONNECTED_PARAMETERS_CHANGED);
